import "./styles.scss";

import { useState, useEffect, useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { useTasks } from "context/webmaster/tasks";

import MobileBar from "components/MobileBar";
import BackMobile from "components/BackMobile";
import Button from "components/Button";
import Select from "components/form/Select";

import task_status_data from "libs/task_status_data.json";
import task_priority_data from "libs/task_priority_data.json";

const mainClass = "tasks-webmaster-modal-filters";

const initial_filters = {
  priority: null,
  status: null,
};

const ModalFilters = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { filters, applyFilters, filterClearAll } = useTasks();

  const [filtersInner, setFiltersInner] = useState(initial_filters);
  const [appliedFilters, setAppliedFilters] = useState(initial_filters);

  useEffect(() => {
    const className = "tasks-webmaster-modal-filters-open";
    document.body.classList.toggle(className, isOpen);
    return () => document.body.classList.remove(className);
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      const priority_filters = filters?.priority?.split(",");
      const status_filters = filters?.status?.split(",");

      const snapshot = {
        priority:
          priority_filters?.length > 0
            ? task_priority_data?.find(
                (item) => item?.key === priority_filters[0],
              ) || null
            : null,
        status:
          status_filters?.length > 0
            ? task_status_data?.find(
                (item) => item?.key === status_filters[0],
              ) || null
            : null,
      };

      setAppliedFilters(snapshot);
      setFiltersInner(snapshot);
    } else {
      setFiltersInner(initial_filters);
      setAppliedFilters(initial_filters);
    }
  }, [filters, isOpen]);

  const isDirty = useMemo(
    () =>
      filtersInner.priority?.key !== appliedFilters.priority?.key ||
      filtersInner.status?.key !== appliedFilters.status?.key,
    [filtersInner, appliedFilters],
  );

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={mainClass}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ type: "tween", duration: 0.2 }}
        >
          <MobileBar onWebsiteClick={onClose} />
          <div className={`${mainClass}__back`}>
            <BackMobile onClick={onClose} />
          </div>
          <div className={`${mainClass}__content`}>
            <div className={`${mainClass}__content-item`}>
              <Select.Priority
                selected={filtersInner.priority}
                onChange={(option) =>
                  setFiltersInner({ ...filtersInner, priority: option })
                }
              />
            </div>
            <div className={`${mainClass}__content-item`}>
              <Select.Status
                selected={filtersInner.status}
                onChange={(option) =>
                  setFiltersInner({ ...filtersInner, status: option })
                }
              />
            </div>
          </div>
          <div className={`${mainClass}__actions`}>
            <Button
              disabled={Object.values(filtersInner).every((value) => !value)}
              onClick={() => {
                filterClearAll();
                setFiltersInner(initial_filters);
                setAppliedFilters(initial_filters);
              }}
            >
              {t("Remove filters")}
            </Button>
            <Button
              disabled={!isDirty}
              onClick={() => {
                applyFilters(filtersInner);
                onClose();
              }}
            >
              {t("Apply filters")}
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalFilters;
